export default [
  {
    path: 'explain',
    title: '帮助说明',
    name: 'explain',
    component: () =>
      import(
        /* webpackChunkName: "helpExplain" */ '@/pages/backStage/helpExplain/list.vue'
      ),
  },
  {
    path: 'access-log',
    title: '访问日志',
    name: 'accessLog',
    component: () =>
      import(
        /* webpackChunkName: "accessLog" */ '@/pages/backStage/accessLog/index.vue'
      ),
  },
  {
    path: 'user-manage',
    title: '用户管理',
    name: 'userManage',
    component: () =>
      import(
          /* webpackChunkName: "userManage" */ '@/pages/backStage/userManage/list.vue'
      ),
  },
  {
    path: 'reset-account',
    title: '重置账号申请列表',
    name: 'resetAccount',
    component: () =>
      import(
          /* webpackChunkName: "resetAccount" */ '@/pages/backStage/resetAccount/index.vue'
      ),
  },
];
